import namespace from "@rdfjs/namespace";
const builder = namespace("http://usefulinc.com/ns/doap#");
export const strict = builder;
export const loose = builder;
